module.exports = __webpack_public_path__ + "static/media/undraw_empty.a35c144e.svg";